import { breakpoints } from "@tvg/design-system";
import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RunnerModifierContainer = styled.div<{
  isDesktopPicksFormat: boolean;
}>`
  position: relative;
  z-index: 1;
  min-width: 530px;
  display: flex;
  flex-direction: row;
  ${({ isDesktopPicksFormat, theme }) =>
    isDesktopPicksFormat
      ? css`
          flex-direction: row-reverse;
        `
      : css`
          padding: ${theme.space["space-4"]};
          background-color: ${theme.colorTokens.background.layer};
          border-bottom: 1px solid ${theme.colorTokens.border.default};
          border-top: 1px solid ${theme.colorTokens.border.default};
        `};

  @media screen and ${breakpoints.tablet.max.sm} {
    min-width: initial;
    padding: ${({ theme }) => theme.space["space-1"]}
      ${({ theme }) => theme.space["space-4"]};
  }
`;

export const OptionGroup = styled.div<{ hasSeparator: boolean }>`
  min-width: 120px;
  ${({ theme, hasSeparator }) =>
    hasSeparator &&
    css`
      border-left-width: 1px;
      border-left-style: solid;
      border-left-color: ${theme.colorTokens.border.default};
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    min-width: initial;
    flex: 1 0 0;
  }
`;

export const OptionGroupsBox = styled.div`
  display: flex;
  flex-direction: row;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: ${({ theme }) => theme.colorTokens.border.default};
`;

export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media screen and ${breakpoints.tablet.min.sm} {
    flex-grow: 4;
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    margin-left: auto;
  }
`;

export const SimpleSelectAllContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  column-gap: ${({ theme }) => theme.space["space-1"]};
`;

export const SimpleSelectAllButton = styled.button<{
  isAllSelected: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 25px;
  padding: 5px 7px;
  background-color: ${({ theme, isAllSelected }) =>
    isAllSelected
      ? theme.colorTokens.component.button.secondary.background.hover
      : theme.colorTokens.component.input.surface};
  border: 1px solid
    ${({ theme, isAllSelected }) =>
      isAllSelected
        ? theme.colorTokens.component.button.tertiary.border.active
        : theme.colorTokens.component.button.tertiary.border.base};
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(17, 43, 68, 0.12);
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, isAllSelected }) =>
      isAllSelected
        ? theme.colorTokens.component.button.secondary.background.base
        : theme.colorTokens.component.button.buttonLink.background.hover};
  }
`;

export const DropdownSelectAllContainer = styled.div`
  position: absolute;
  overflow: hidden;
  z-index: 3;
  display: flex;
  width: 100%;
  flex-direction: column;
  top: 43px;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  border: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  box-shadow: 0 1px 3px rgba(17, 43, 68, 0.12);
  border-radius: 4px;
`;

export const DropdownSelectAllButton = styled.button<{
  isSelected: boolean;
}>`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  height: 42px;
  padding: ${({ theme }) => theme.space["space-4"]};
  background-color: ${({ theme, isSelected }) =>
    isSelected
      ? theme.colorTokens.component.button.tertiary.background.hover
      : theme.colorTokens.component.button.tertiary.background.base};
  ${({ theme, isSelected }) =>
    isSelected &&
    css`
      border-left-width: 2px;
      border-left-style: solid;
      border-left-color: ${theme.colorTokens.content.link};
    `}
  &:hover {
    background-color: ${({ theme }) =>
      theme.colorTokens.component.button.tertiary.background.hover};
  }
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.space["space-4"]};
  border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
`;

export const Divider = styled.div`
  display: inline-flex;
  align-self: center;
  width: 1px;
  height: 12px;
  margin: 0 ${({ theme }) => theme.space["space-1"]};
  background-color: ${({ theme }) => theme.colorTokens.content.subtle3};
`;

export const SegmentedControlContainer = styled.div`
  flex-direction: column;
  overflow: hidden;
  padding: 0 ${({ theme }) => theme.space["space-4"]};
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
`;

export const RaceCardViewButtonContainer = styled.div<{
  isActive?: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  border-radius: 2px;
  background-color: ${({ theme, isActive }) =>
    isActive
      ? theme.colorTokens.component.button.buttonLink.background.active
      : "transparent"};
`;
